// extracted by mini-css-extract-plugin
export var closeButton = "_60-0";